/* eslint-disable no-unused-vars */
import React, { Component , useRef}  from "react";
import  { Redirect } from 'react-router-dom'
// import  { useRef   }  from "react";
// import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from 'moment';
import validator from 'validator';
import MainLayout from "../layout/main-layout";
import Header from '../layout/Header';
import Left from '../layout/Left';
import DatePicker from "react-datepicker";
import valid from "card-validator";
// import ReactSession from 'react-client-session';
import { getPaymentInfo, setPaymentInfo } from '../../actions/payActions'

class PaymentInformation extends Component {


    constructor(props){
        super(props);
        this.state={
            error:'',
            errors:{},
            paymentInfo:{},
            paymentInfo_update:{},
            formData:{Source:"Humanaut Physician Portal",Payment_Type:"",PaymentMethod:"",PhysicianFirstName:"",PhysicianLastName:""}, 
            IPData:[],
            login:true, 
            msg:"",    
            loading:true,
            card_last_gid:"",
            Payment_Type:"CC",
            acc_num:""
        }
    }

    componentDidMount() {            
        
          
        var physician_id = localStorage.getItem('physician_id');
        if(physician_id != ""){
            // console.log('imrn')
            // console.log('physician_id ', physician_id)
            this.state.paymentInfo['PhysicianId'] = physician_id
            this.props.getPaymentInfo(physician_id,this.props.history);  
        }
                
    }

    componentWillReceiveProps(nextProps) {
        // console.log('nextProps ----------',nextProps); 
        if(nextProps.page_name.pay_info){
            // this.state.paymentInfo = nextProps.page_name.page_name
            this.state.paymentInfo['Credit_Card_Holder_First_Name'] = nextProps.page_name.pay_info.Credit_Card_Holder_First_Name__c
            this.state.paymentInfo['Credit_Card_Holder_Last_Name'] = nextProps.page_name.pay_info.Credit_Card_Holder_Last_Name__c
            this.state.paymentInfo['Credit_Card_Billing_Zip_Code'] = nextProps.page_name.pay_info.Credit_Card_Billing_Zip_Code__c
            this.state.paymentInfo['CVV'] = nextProps.page_name.pay_info.CVV__c
            this.state.paymentInfo['Credit_Card_Number'] = nextProps.page_name.pay_info.Credit_Card_Number__c
            this.state.paymentInfo['Month_of_Expiry'] = nextProps.page_name.pay_info.Month_of_Expiry__c
            this.state.paymentInfo['Year_of_Expiry'] = nextProps.page_name.pay_info.Year_of_Expiry__c
            this.state.paymentInfo['PhysicianId'] = nextProps.page_name.pay_info.Id
            this.state.paymentInfo['FirstName'] = nextProps.page_name.pay_info.FirstName
            this.state.paymentInfo['LastName'] = nextProps.page_name.pay_info.LastName
            this.state.paymentInfo['Account_Number'] = nextProps.page_name.pay_info.Account_Number__c
            this.state.paymentInfo['Name_On_Account'] = nextProps.page_name.pay_info.Name_on_ACH_Account__c
           
            if(nextProps.page_name.pay_info.Credit_Card_Number__c != null){
                var nu =  nextProps.page_name.pay_info.Credit_Card_Number__c
                this.state.card_last_gid = nu.slice(nu.length - 4);
            }
            if(nextProps.page_name.pay_info.Account_Number__c != null){
            
                var acc_num = nextProps.page_name.pay_info.Account_Number__c;
                this.state.acc_num = acc_num.slice(acc_num.length - 4)
            }
            this.setState({loading:false})
            // console.log('paymentInfo data', this.state.paymentInfo) 
        } 

        if(nextProps.page_name.payment_info){

            this.setState({loading:false})
           
            if(nextProps.page_name.payment_info.error){
                this.setState({api_error:nextProps.page_name.payment_info.error})
            }else{
                this.state.formData['TransactionId'] = nextProps.page_name.payment_info.TransactionId
                this.setState({payment_response:nextProps.page_name.payment_info.page_name})
            }
            
            this.setState({loading:false})
            window.scrollTo(0, 0);     
    
        }


        if(nextProps.page_name.res){
            this.state.msg = nextProps.page_name.res
            this.setState({loading:false})
        }


    }

    onChange = (e) => {  
        this.state.formData[e.target.id] = e.target.value; 
        console.log('paymentInfo value=>', this.state.formData);
    }

    Update_payment_typ = (e) => {

        console.log('payment type', e.target.value);
        this.setState({Payment_Type:e.target.value});
        this.state.formData['Payment_Type'] = e.target.value; 

        

    }

    onACHSubmit = (e) => {
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;

        if(!fields["Account_Number"]){
            formIsValid = false;
            errors["Account_Number"] = "Please enter account number";
            let element = document.getElementById("Account_Number");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["Name_On_Account"]){
            formIsValid = false;
            errors["Name_On_Account"] = "Field cann't be empty";
            let element = document.getElementById("Name_On_Account");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["ABA_Routing_Number"]){
            formIsValid = false;
            errors["ABA_Routing_Number"] = "Field cann't be empty";
            let element = document.getElementById("ABA_Routing_Number");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        this.setState({errors: errors});
        
        if(formIsValid){
            // this.setState({ loading: true });  
            const newList = this.state.formData;
            newList['PhysicianId'] = this.state.paymentInfo['PhysicianId']
            newList['FirstName'] = this.state.paymentInfo['FirstName']
            newList['LastName'] = this.state.paymentInfo['LastName']
            newList['Payment_Type'] = 'ACH';
            console.log("newlist=>", newList);
            this.setState({loading:true})
            this.props.setPaymentInfo(newList, this.props.history);
            }


    }

    onSubmit = (e) => {              
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;
        

        
        if(!fields["Credit_Card_Number"]){
            formIsValid = false;
            errors["Credit_Card_Number"] = "Please enter credit card number";
            let element = document.getElementById("Credit_Card_Number");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(fields["Credit_Card_Number"]) {
            let cardvalid = valid.number(fields["Credit_Card_Number"]);
            // console.log('cardvalid',cardvalid);
            if(!cardvalid.isValid){
                formIsValid = false;
                errors["Credit_Card_Number"] = "Invalid credit card number.";
                let element = document.getElementById("Credit_Card_Number");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
            }
        }

        if(!fields["Credit_Card_Holder_First_Name"]){
            formIsValid = false;
            errors["Credit_Card_Holder_First_Name"] = "Field cann't be empty";
            let element = document.getElementById("Credit_Card_Holder_First_Name");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Credit_Card_Holder_Last_Name"]){
            formIsValid = false;
            errors["Credit_Card_Holder_Last_Name"] = "Field cann't be empty";
            let element = document.getElementById("Credit_Card_Holder_Last_Name");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["CVV"]){
            formIsValid = false;
            errors["CVV"] = "Field cann't be empty";
            let element = document.getElementById("CVV");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(fields["CVV"] && !/^\d{3,4}$/.test(fields["CVV"])) {
            formIsValid = false;
            errors["CVV"] = "Invalid CVV code"; 
            let element = document.getElementById("CVV");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});   
            element.className = "form-control error"            
        }

        if(!fields["Month_of_Expiry"]){
            formIsValid = false;
            errors["Month_of_Expiry"] = "Cannot be empty";
            let element = document.getElementById("Month_of_Expiry");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
        } 

        if(fields["Month_of_Expiry"]){

            let expMonth = valid.expirationMonth(fields["Month_of_Expiry"]);
            // console.log('expmonth',expMonth.isPotentiallyValid);
            if(!expMonth.isPotentiallyValid){
                formIsValid = false;
                errors["Month_of_Expiry"] = "Invalid credit Card Expiration Month";
                let element = document.getElementById("Month_of_Expiry");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
            }
        }

        if(!fields["Year_of_Expiry"]){
            formIsValid = false;
            errors["Year_of_Expiry"] = "Cannot be empty";
            let element = document.getElementById("Year_of_Expiry");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
            } 

            if(fields["Year_of_Expiry"]){
                let expirationYear = valid.expirationYear(fields["Year_of_Expiry"]);
                // console.log('expirationYear',expirationYear.isPotentiallyValid);
                if(!expirationYear.isPotentiallyValid){
                    formIsValid = false;
                    errors["Year_of_Expiry"] = "Invalid credit Card Expiration Year";
                    let element = document.getElementById("Year_of_Expiry");                
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                }
            }

            if(fields["Year_of_Expiry"] && fields["Month_of_Expiry"]){
                let expirationDate = valid.expirationDate(fields["Month_of_Expiry"]+"/"+fields["Year_of_Expiry"]);
                // console.log('expirationDate',expirationDate);
                if(!expirationDate.isPotentiallyValid){
                    formIsValid = false;
                    errors["Year_of_Expiry"] = "Something Wrong with Expiration Year";
                    let element = document.getElementById("Year_of_Expiry");                
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});

                    errors["Month_of_Expiry"] = "Something Wrong with Expiration Month";
                    let element1 = document.getElementById("Month_of_Expiry");                
                    element1.scrollIntoView({behavior: 'smooth'});
                    element.className = "form-control error"
                }
            }



        if(!fields["Credit_Card_Billing_Zip_Code"]){
            formIsValid = false;
            errors["Credit_Card_Billing_Zip_Code"] = "Field cann't be empty";
            let element = document.getElementById("Credit_Card_Billing_Zip_Code");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Country"]){
            formIsValid = false;
            errors["Country"] = "Field cann't be empty";
            let element = document.getElementById("Country");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

   

        
        this.setState({errors: errors});
        
        if(formIsValid){
            // this.setState({ loading: true });  
            const newList = this.state.formData;
            newList['PhysicianId'] = this.state.paymentInfo['PhysicianId']
            newList['Payment_Type'] = 'CC';
            newList['FirstName'] = this.state.paymentInfo['FirstName']
            newList['LastName'] = this.state.paymentInfo['LastName']
            console.log("newlist=>", newList);
            this.setState({loading:true})
            this.props.setPaymentInfo(newList, this.props.history);
            }

    }    



    render() {
        const {paymentInfo} = this.state
        if(!sessionStorage.getItem('physician_id') || sessionStorage.getItem('physician_id')==null) {           
            return <Redirect to="../" />
          } 
        return (
            <MainLayout>
                <Header />
                { (this.state.loading)?
                <div class="loading-div">
                    <div class="loading-img"><img src="images/spinner.svg" alt="" /></div>
                </div>:""}
                <div className="main-content">
                    <Left activeMenu={"payment-information"}/> 
                    <div class="right-section">
                    <div class="pagesubheader-wrap">
                        <div class="pagesubheader-row">
                            <div class="page-subheader-col-left">
                                <div class="title-avatar">
                                    <img src="images/credit-card.svg" alt="" />
                                </div>
                                <div class="title-main">
                                    <span class="title-sub-text">Physician Portal</span>
                                    <h1>Update Payment Information</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    { (this.state.payment_response)?
                    <div className="col-md-12">
                        <h5 style={{paddingTop:"10px"}}><i>Information is Updated Sucessfully</i> </h5>
                    </div>:
                    <div>
                    <div class="inner-content-area">
                    <span style={{color: "red"}}>{this.state.api_error}</span>   
                    <div class="payment-info">
                        <form className="needs-validation" noValidate onSubmit={this.onSubmit}>
                        <div class="card">
                            <div class="card-header">
                                <h4>Current Payment Method Secured For Annual Banking </h4>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck2" checked />
                                    <label class="custom-control-label" for="customCheck2"></label>
                                    </div>
                            </div>
                            <div class="card-body">
                                <div class="saved-card-detail">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label>Card Number</label>
                                            <div class="card-dtl-value">
                                                <img class="card-logo" src="images/master-card.png" alt="" />
                                                <span>Credit Card ending in {this.state.card_last_gid}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label>Name on card</label>
                                            <div class="card-dtl-value">
                                                <span>
                                                    {(paymentInfo.Credit_Card_Holder_First_Name)?
                                                    paymentInfo.Credit_Card_Holder_First_Name + " "+ paymentInfo.Credit_Card_Holder_Last_Name : "NA"}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label>Expiry</label>
                                            <div class="card-dtl-value">
                                                <span>
                                                    {(this.state.paymentInfo.Month_of_Expiry)?                                                    
                                                    this.state.paymentInfo.Month_of_Expiry+ ' / '+ this.state.paymentInfo.Year_of_Expiry: "NA" }  </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-edit-option">
                                    <div class="update-card-row">
                                        <h4>Update Credit Card Information For Annual Banking</h4> <button type="button" class="btn btn-primary btn-edit" value="CC" onClick={this.Update_payment_typ}><img src="images/edit.svg" alt="" /> Edit</button>
                                    </div>
                                    
                                    <div class="update-payment">
                                    <h4>Update Payment Method</h4>

                                    
                                    
                                    
                                    <div class="card-detail-form">
                                        <div class="card-detail-wrap mb-5">
                                        <h5>Credit Card Detail <img src="images/info.svg" data-toggle="tooltip" data-placement="top" title="Tooltip Text" alt="" /></h5>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Credit Card Number <span class="required">*</span> </label>
                                                    <input type="text" id="Credit_Card_Number" class="form-control" placeholder="" onChange={this.onChange} />
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Number"]}</span>
                                                </div>
                                            </div>
                                            {/* <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>Expiry Date <span class="required">*</span> </label>
                                                    <input type="text" id="" class="form-control" placeholder="-- --  /  -- -- -- --" />
                                                </div>
                                            </div> */}

                                            <div class="col-md-3">
                                                <div class="form-group">
                                                    <label>CVV <span class="required">*</span> </label>
                                                    <input id="CVV" type="password" class="form-control" placeholder="***" onChange={this.onChange} />
                                                    <span style={{color: "red"}}>{this.state.errors["CVV"]}</span>
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                            <label htmlFor="Month_of_Expiry">Card Expiration Date <span className="act_required">*</span></label>
                                            <select className="custom-select d-block w-100" id="Month_of_Expiry" onChange={this.onChange}  placeholder="mm" >
                                                <option value="">Select Month</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option> 
                                                <option value="03">03</option> 
                                                <option value="04">04</option> 
                                                <option value="05">05</option>    
                                                <option value="06">06</option> 
                                                <option value="07">07</option> 
                                                <option value="08">08</option> 
                                                <option value="09">09</option> 
                                                <option value="10">10</option> 
                                                <option value="11">11</option>
                                                <option value="12">12</option>  
                                            </select>
                                            {/* <input type="text" className="form-control" id="Month_of_Expiry" onChange={this.onChange} placeholder="mm" required /> */}
                                            <span style={{color: "red"}}>{this.state.errors["Month_of_Expiry"]}</span>
                                            <div className="invalid-feedback">
                                            Valid Month required
                                            </div>
                                            </div>

                                                <div className="col-md-2 mb-3">
                                                <label htmlFor="creditCardExpirationYear"> &nbsp;</label>
                                                <select className="custom-select d-block w-100" id="Year_of_Expiry" onChange={this.onChange}  placeholder="YYYY" >
                                                <option value="">Year</option>
                                               
                                                {/* <option value="2024">2024</option> */}
                                                <option value="2025">2025</option>
                                                <option value="2026">2026</option>
                                                <option value="2027">2027</option>
                                                <option value="2028">2028</option>
                                                <option value="2029">2029</option>
                                                <option value="2030">2030</option>
                                                <option value="2031">2031</option>
                                                <option value="2032">2032</option>
                                                
                                                </select>
                                                {/* <input type="text" className="form-control" id="creditCardExpirationYear" onChange={this.onChange} placeholder="yy" required /> */}
                                                
                                                <span style={{color: "red"}}>{this.state.errors["Year_of_Expiry"]}</span><div className="invalid-feedback">
                                                Valid Year required
                                                </div>
                                                </div>

                                            
                                            <div class="col-md-12">
                                                <div class="card-logo-list">
                                                <div><img src="images/card-1.svg" alt="" /></div>
                                                <div><img src="images/card-2.svg" alt="" /></div>
                                                <div><img src="images/card-3.svg" alt="" /></div>
                                                <div><img src="images/card-4.svg" alt="" /></div>
                                                    </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="card-detail-wrap">
                                            <h5>Billing Address <img src="images/info.svg" data-toggle="tooltip" data-placement="top" title="Tooltip Text" alt="" /></h5>
                                        <div class="row">
                                            
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>First Name</label>
                                                    <input type="text" id="Credit_Card_Holder_First_Name" class="form-control" placeholder="" onChange={this.onChange} />
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Holder_First_Name"]}</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Last Name</label>
                                                    <input type="text" id="Credit_Card_Holder_Last_Name" class="form-control" placeholder="" onChange={this.onChange} />
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Holder_Last_Name"]}</span>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Country</label>
                                                    <input type="text" id="Country" class="form-control" placeholder="" onChange={this.onChange} /> 
                                                    <span style={{color: "red"}}>{this.state.errors["Country"]}</span>
                                                
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Zip/Postal Code</label>
                                                    <input type="text" id="Credit_Card_Billing_Zip_Code" class="form-control" placeholder="" onChange={this.onChange} /> 
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Billing_Zip_Code"]}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div className="custom-control custom-checkbox">
                                    {/* <input type="checkbox" id="ACH_payment" name="ACH_payment" className="custom-control-input" value="true" onClick={this.ACH_payment}/>
                                    <label className="custom-control-label" for="ACH_payment">Add ACH Payment Details</label> */}
                                  
                                    </div>
                                    {(this.state.ACH_payment == true)?
                                     <div class="card-detail-form">
                                     <div class="card-detail-wrap mb-5">
                                     <h5>ACH <img src="images/info.svg" data-toggle="tooltip" data-placement="top" title="Tooltip Text" alt="" /></h5>
                                     <div class="row">
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>Name On Account <span class="required">*</span> </label>
                                                 <input type="text" id="Name_on_account" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Name_on_account"]}</span>
                                             </div>
                                         </div>
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>Account Number<span class="required">*</span> </label>
                                                 <input type="text" id="Name_on_account" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Name_on_account"]}</span>
                                             </div>
                                         </div>
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>ABA Routing Number <span class="required">*</span> </label>
                                                 <input type="text" id="Name_on_account" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Name_on_account"]}</span>
                                             </div>
                                         </div>

                                    </div>
                                    </div></div>: ""}
                                    
                                </div>
                                
                                </div>

                                

                            </div>
                            </div>

                            <div class="button-area">
                            <button type="button" class="btn btn-outline-primary mr-2">Cancel</button>
                            <button type="submit" class="btn btn-primary">Save</button>
                        </div>
                        </form>

                        </div>
                        <p></p>
                        <div class="ach-payment-info">
                    <form className="needs-validation" noValidate onSubmit={this.onACHSubmit}>

                        <div class="card">
                            <div class="card-header">
                                <h4> ACH Payment </h4>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck2" checked />
                                    <label class="custom-control-label" for="customCheck2"></label>
                                    </div>
                            </div>
                            <div class="card-body">
                            <div class="saved-card-detail">
                                    <div class="row">
                                    <div class="col-md-6">
                                            <label>Account Number</label>
                                            <div class="card-dtl-value">
                                                <span>Account Number Ending in *****{this.state.acc_num}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label> Name On Account</label>
                                            <div class="card-dtl-value">
                                                
                                                <span> {paymentInfo.Name_On_Account}</span>
                                            </div>
                                        </div>
                                        
                                        
                                    </div>
                            </div>
                            <br></br>
                            
                            
                            <div class="card-edit-option" >
                                    <div class="update-card-row">
                                        <h4>Update ACH Payment</h4> <button type="button" class="btn btn-primary ach_edit" value="ACH" onClick={this.Update_payment_typ}><img src="images/edit.svg" alt="" /> Edit</button>
                                    </div>
                                    
                                    <div class="ach-update-payment">
                                    <div class="card-detail-form">
                                     <div class="card-detail-wrap mb-5">
                                     <h5>ACH <img src="images/info.svg" data-toggle="tooltip" data-placement="top" title="ACH Payment Details" alt="" /></h5>
                                     <div class="row">
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>Name On Account <span class="required">*</span> </label>
                                                 <input type="text" id="Name_On_Account" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Name_On_Account"]}</span>
                                             </div>
                                         </div>
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>Account Number<span class="required">*</span> </label>
                                                 <input type="text" id="Account_Number" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Account_Number"]}</span>
                                             </div>
                                         </div>
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>ABA Routing Number <span class="required">*</span> </label>
                                                 <input type="text" id="ABA_Routing_Number" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["ABA_Routing_Number"]}</span>
                                             </div>
                                         </div>
                                    </div>
                                    </div>
                                    
                                        <div class="button-area">
                                        <button type="button" class="btn btn-outline-primary ach-cancel mr-2" value="" onClick={this.Update_payment_typ}>Cancel</button>
                                        <button type="submit" class="btn btn-primary">Save</button>
                                        </div>
                                    </div>

                            </div>
                            </div>
                            </div>
                        </div>
                    </form>
                    </div> 
                    
                    </div> </div>} </div>
                    </div>                
            </MainLayout>
        );
    }
}

PaymentInformation.propTypes = {
    errors: PropTypes.object.isRequired,
    error: PropTypes.object.isRequired,
    setPaymentInfo:PropTypes.func.isRequired,    
    getPaymentInfo:PropTypes.func.isRequired,
};



const mapStateToProps = (state) => ({
    page_name : state.pay,
    errors: state.errors,
  });


export default connect(mapStateToProps, {getPaymentInfo, setPaymentInfo })(PaymentInformation);